import(/* webpackMode: "eager" */ "/home/runner/work/Planner/Planner/app/goals/error.tsx");
